import React, { useCallback, useEffect, useState } from "react";
import ButirDashboard from "../components/etams/ButirDashboard";
import KotakTugasSaya from "../components/etams/KotakTugasSaya";
import GrafikOwner from "../components/etams/GrafikOwner";
import { Link } from "react-router-dom";
import { ANALITIK_ROLES, KPI_ROLES } from "../lib/roles";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Clock, ListTodo, Palette, Wallet, Banknote, ShieldCheck, Circle, Wrench, Factory, ClipboardList, Gauge, TriangleAlert } from "lucide-react";
import { GRUP, grupUntuk, umurHari, eskalasiTerjauh } from "../lib/notifikasi";
import {
  useRealtimeTable,
  useVisiblePolling,
  REALTIME_DOWN_POLL_MS,
} from "../lib/useRealtimeTable";
import { formatDate, formatIDR, isoPlusDays } from "../lib/format";
import { toast } from "sonner";
import { apiErrorMessage } from "../lib/inventoryApi";
import { FA_STATUS_LABEL } from "../lib/statusLabels";

function daysUntil(dateStr) {
  if (!dateStr) return null;
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const t = new Date(dateStr); t.setHours(0, 0, 0, 0);
  return Math.round((t - today) / 86400000);
}


// ⛔ PETA RUTE DITULIS ULANG 27 Agustus 2026 — versi lama 100% MATI.
//
// Versi warisan `NotificationsBell.jsx` memetakan LIMA nama jenis:
// ADJUSTMENT_PENDING · DESIGN_FINAL_SUBMITTED · FA_SUBMITTED ·
// PAYMENT_CONFIRMED · PAYMENT_SUBMITTED. Diukur lewat UAT 27 Agustus terhadap
// 16 jenis yang SAH di CHECK `notifications.type`: **IRISANNYA KOSONG.**
// Kelimanya menunjuk jenis yang tidak mungkin ada.
//
// Artinya sejak lonceng dibangun, mengklik notifikasi NOL PERNAH membawa ke
// mana pun. Satu-satunya yang berfungsi adalah `dismiss` — menghapusnya dari
// daftar. Itu menjelaskan tumpukan 5.425 notifikasi ACTIVE dengan tepat:
// mengklik tidak berguna, jadi orang berhenti mengklik, jadi nol yang pernah
// selesai.
//
// ⚠ Nol test yang bisa menemukannya: petanya sintaksis SAH, fallback-nya ada,
// semuanya hijau. Yang salah cuma NAMA — dan nama yang salah tidak pernah
// melempar galat, ia hanya diam-diam tidak cocok.
//
// ---------------------------------------------------------------------
// KENAPA SEKARANG DIPETAKAN DARI `related_entity_type`, BUKAN DARI `type`
// ---------------------------------------------------------------------
// `type` adalah alasan notifikasi terbit; `related_entity_type` adalah BENDA
// yang dirujuknya. Yang menentukan tujuan layar adalah bendanya. Memetakan
// dari `type` menuntut peta ini diperbarui tiap jenis baru lahir — dan justru
// kelalaian itu yang membuat versi lama mati tanpa ada yang tahu.
//
// Dipetakan dari benda, jenis baru yang merujuk benda yang sudah dikenal
// LANGSUNG bertaut, nol suntingan.
//
// ⚠ `design_request` DAN `design_requests` dua-duanya ada di data —
// `NOTIF-ENTITY-TYPE-DUA-EJAAN-01` di BACKLOG. Keduanya diterima DI SINI
// supaya separuh notifikasi desain tidak kehilangan tautannya sambil menunggu
// perbaikan datanya. Ini penambal, bukan penyelesaian: jangan hapus salah
// satunya sebelum datanya diseragamkan.
const ENTITAS_KE_RUTE = {
  design_request:   (id) => `/design-requests/${id}`,
  design_requests:  (id) => `/design-requests/${id}`,
  design_task:      (id) => `/design-tasks/${id}`,
  fa_order:         (id) => `/fa-orders/${id}`,
  fa_orders:        (id) => `/fa-orders/${id}`,
  vendor_invoice:   (id) => `/purchasing/invoices/${id}`,
  purchase_order:   (id) => `/purchasing/po/${id}`,
  purchase_request: (id) => `/purchasing/pr/${id}`,
  // K78: perubahan tarif borongan menunggu Owner — diputus dari kartu antrean di layar Tarif Borongan.
  sewing_rate_changes: () => "/master/tarif-borongan",
  // T107: kabar ke Owner tiap rekening resmi cabang berubah (sasaran penipuan) — diperiksa di layar masternya.
  rekening_resmi:   () => "/master/rekening-resmi",
  vendor_down_payment: (id) => `/purchasing/dp/${id}`,
  // Tiga ini nol punya halaman DETAIL — rutenya daftar, dan itu memang
  // tujuan yang benar: pekerjaannya dikerjakan dari daftarnya.
  receivable:       () => "/receivables",
  foc_request:      () => "/foc-requests",
  special_customer: () => "/special-customers",
  // Pengingat repeat order musiman (K179 langkah 27): CS membuka customer-nya lalu menghubungi.
  customer:         (id) => `/customers/${id}`,
  // K197 butir 3: penyelesaian retur menunggu persetujuan KC — diputus dari layar Retur Vendor.
  vendor_return:    () => "/purchasing/returns",
  // K197 butir 5: pemindahan bahan baku menunggu persetujuan KC — diputus dari layar Pindah Bahan.
  bahan_pindah:     () => "/inventory/pindah-bahan",
  // B-33: pengingat hari bayar gaji (Finance + Owner) — dikerjakan dari layar Payroll.
  payroll_periode:  () => "/hrd/payroll",
  // BUSINESS-50/51/52 (26 Sep 2026): FA menunggu DP, pengajuan batal, izin Owner customer penunggak, barang jadi
  // belum diambil — semuanya dikerjakan dari layar Tindak Lanjut Pesanan (tab sesuai jenisnya).
  fa_menunggu_dp:          () => "/tindak-lanjut-pesanan?tab=dp",
  fa_pengajuan_batal:      () => "/tindak-lanjut-pesanan?tab=dp",
  pengecualian_tunggakan:  () => "/tindak-lanjut-pesanan?tab=tunggakan",
  barang_jadi_menunggu:    () => "/tindak-lanjut-pesanan?tab=barang",
  // Kiriman WA yang MENYERAH sesudah 5 percobaan (wa_outbox). Pekerjaannya
  // "hubungi customer lewat jalur lain", dan tempat melihat seluruh riwayat
  // kontak orang itu adalah layar Percakapan — bukan halaman detail pesan,
  // yang memang nol ada.
  wa_message:       () => "/percakapan",
  // BUSINESS-100 (25 Okt 2026): WhatsApp penting ke customer belum sampai — CS menyalin isi pesan + tautan dan
  // mencatat hasilnya (sudah dihubungi / nomor salah / nomor tidak aktif) di layar Kanal WhatsApp.
  wa_tugas_kirim:   () => "/kanal-wa",
  // K207 W5: eskalasi AI WhatsApp — ditandai diambil alih / selesai dari panel di layar Percakapan.
  wa_eskalasi:      () => "/percakapan",
  // K210 BUSINESS-73: KC diberi tahu nomor cabangnya sunyi / pesan cabangnya tertahan (id = region).
  wa_kanal_cabang:  () => "/kanal-wa",
  // Tahap produksi yang NOL ADA YANG HADIR hari itu (tugas_harian K126
  // butir 4). Yang pertama dibutuhkan Admin Produksi adalah SIAPA yang
  // seharusnya ada di tahap itu — bukan beban tahapnya — dan matriks
  // personil yang menjawabnya. Rute daftar; id-nya diisi tapi nol dipakai
  // di sini, sama seperti receivable → /receivables.
  production_stage: () => "/personil",
  // Tugas satu tahap pada satu WO yang MENYERAH sesudah 5 percobaan kirim.
  // Judulnya sudah menyebut wo_number, jadi tujuan terdekat dengan
  // pekerjaannya adalah WO itu sendiri.
  //
  // ⚠ SENGAJA tipe TERPISAH dari production_stage, bukan satu tipe dua id:
  // dua pekerjaan berbeda menuntut dua tujuan berbeda, dan peta ini dikunci
  // per tipe. Satu tipe dua jenis id adalah kelas yang melahirkan
  // NOTIF-ENTITY-TYPE-DUA-EJAAN-01.
  wo_stage_task:    (id) => `/wo/${id}`,
  // Bahan yang saldonya menembus min_stock_level (stok_menipis, K19).
  // Pekerjaannya "ajukan PR kalau memang perlu", dan daftar bahan yang
  // menunjukkan saldo per gudang adalah tempat memutuskannya. Rute daftar —
  // halaman detail bahan memang nol ada.
  raw_material:     () => "/inventory/materials",
  // WO yang sisa waktunya nol cukup untuk sisa pekerjaannya (alarm produksi
  // K161). Pekerjaannya "geser antrean, tambah orang, atau mulai sekarang" —
  // dan ketiganya diputuskan sambil melihat WO-nya sendiri.
  //
  // ⚠ Rute yang SAMA dengan `wo_stage_task`, dan itu benar: keduanya menunjuk
  // ke satu WO. Yang berbeda pekerjaannya, bukan tujuannya — dan tipe tetap
  // dipisah supaya kalau kelak salah satunya butuh tujuan lain, memindahkannya
  // nol menyeret yang lain.
  work_order:       (id) => `/wo/${id}`,
  // Aset & Maintenance (Tahap 4b-3, 16 Sep 2026) — cermin konstanta
  // `services/aset_pengingat.ENTITAS_*`. Jadwal jatuh tempo / terlambat
  // menunjuk ASET-nya (halaman detail bertab Jadwal, tempat Catat Servis
  // dan jadwalnya dilihat bersama). Laporan bulanan menuju LAYAR DAFTAR
  // kewajiban lapor — pekerjaannya "lapor semua yang belum", bukan satu
  // aset; id-nya (aset_id) diisi tapi nol dipakai, pola receivable.
  aset:                 (id) => `/aset/${id}`,
  aset_laporan_bulanan: () => "/aset/laporan-bulanan",
  // Ringkasan harian Papan Kontrol (K180 §Kanal, K158; `papan_kontrol.
  // ringkasan_harian`). Pekerjaannya "buka temuan yang terbuka lalu tutup
  // dengan alasan" — layar daftar temuan; id ringkasan diisi tapi tidak
  // dipakai, pola receivable. ⚠ Tertinggal di U24 (21 Sep 2026) dan
  // ditangkap `test_notif_entitas_dari_kode` saat regresi U30: kartunya
  // sempat mati (rute tidak ada) sebelum satu ringkasan pun terbit.
  temuan_ringkasan_harian: () => "/papan-kontrol",
  // BUSINESS-49: koreksi jumlah serah terima menunggu Kepala Cabang — diputus dari panel koreksi di layar
  // Serah Terima Tahap (rute daftar; id koreksi diisi tapi tidak dipakai, pola receivable).
  koreksi_serah_terima: () => "/borongan/serah-terima",
  // K229: "Tidak sesuai" / "Ajukan koreksi" serah terima tahap dari Telegram.
  serah_terima_tg_laporan: () => "/borongan/serah-terima",
};

function routeForNotif(n) {
  const fn = ENTITAS_KE_RUTE[n.related_entity_type];
  if (!fn) return null;
  if (!n.related_entity_id) return null;
  return fn(n.related_entity_id);
}

// Nama ikon di `lib/notifikasi` disimpan sebagai STRING, bukan komponen:
// lib itu polos dan nol boleh mengimpor React. Pemetaannya di sini.
const IKON_GRUP = { Palette, Wallet, Banknote, ShieldCheck, Circle, Wrench, Factory, ClipboardList, Gauge, TriangleAlert };

function deadlineBadge(days) {
  if (days === null) return null;
  if (days < 0) return <Badge className="bg-danger-soft text-danger-soft-foreground border-danger-soft-border border">{Math.abs(days)} hari telat</Badge>;
  if (days === 0) return <Badge className="bg-danger-soft text-danger-soft-foreground border-danger-soft-border border">Hari ini</Badge>;
  if (days <= 3) return <Badge className="bg-warning-soft text-warning-soft-foreground border-warning-soft-border border">{days} hari lagi</Badge>;
  return <Badge className="bg-success-soft text-success-soft-foreground border-success-soft-border border">{days} hari lagi</Badge>;
}

export default function Dashboard() {
  const { profile, appMode, isOwner, isKepalaCabang } = useAuth();
  const showDeadlineCard = isOwner || isKepalaCabang;
  const [nearDeadline, setNearDeadline] = useState([]);
  const [custMap, setCustMap] = useState({});
  const [loadingDl, setLoadingDl] = useState(showDeadlineCard);
  //: Plafon pindai FA tersentuh. Kalau TRUE, "0 FA" berarti "nol di antara
  //: yang sempat dilihat" — bukan "nol". Ditampilkan, bukan disimpan diam.
  const [dlTerpotong, setDlTerpotong] = useState(false);

  // ---- Indikator bulanan (Owner semua region, KC region sendiri) --------
  // Server yang menghitung — /api/dashboard/ringkasan — bukan tarik-lalu-
  // saring di browser seperti kartu tenggat lama yang plafon 200-nya
  // melewatkan baris tanpa suara. `terpotong` dari server ikut ditampilkan.
  const [ringkasan, setRingkasan] = useState(null);
  const [loadingRk, setLoadingRk] = useState(showDeadlineCard);

  // ---- Tugas saya (menggantikan lonceng header) ------------------------
  // Owner 27 Agustus: "notifikasi tampil dalam bentuk card di dashboard,
  // saya rasa lonceng tidak perlu". Daftar tugas yang tidak boleh hilang
  // sebelum dikerjakan tidak pantas bersembunyi di balik ikon kecil.
  //
  // ⚠ Kartu ini untuk SEMUA peran, bukan hanya Owner/KC — justru CS, produksi
  // dan gudang yang paling sering punya tugas menunggu.
  const [tugas, setTugas] = useState([]);
  const [totalTugas, setTotalTugas] = useState(0);
  const [loadingTg, setLoadingTg] = useState(true);

  // Tugas dikelompokkan memakai taksonomi yang SAMA dengan layar saklar
  // notifikasi — nol taksonomi kedua. Urutan grup mengikuti `GRUP`, dan
  // "Lainnya" selalu terakhir supaya jenis yang belum dikenal nol hilang.
  const kelompokTugas = React.useMemo(() => {
    const peta = new Map();
    for (const n of tugas) {
      const g = grupUntuk(n.type);
      if (!peta.has(g.judul)) peta.set(g.judul, { ...g, baris: [] });
      peta.get(g.judul).baris.push(n);
    }
    const urut = [...GRUP.map((g) => g.judul), "Lainnya"];
    return urut.map((j) => peta.get(j)).filter(Boolean);
  }, [tugas]);

  const loadTugas = useCallback(async () => {
    // ⚠ SENGAJA NOL `setLoadingTg(true)` di sini. Keadaan awalnya sudah
    // `true`, jadi muat PERTAMA tetap menampilkan "Memuat...". Yang dihapus
    // adalah pengosongan pada tiap PENYEGARAN — kartu yang menghapus isinya
    // sendiri tiap beberapa detik membuat orang yang sedang membaca satu
    // baris kehilangan barisnya di tengah baca.
    try {
      // ⛔ `urut: "terlama"` — DIUBAH 27 Agustus 2026 setelah pengukuran.
      //
      // Diukur: 240 tugas aktif, hanya 49 lahir hari itu, dan 32 sudah
      // menunggu 25 HARI. Kartu ini dulu mengambil 15 TERBARU — jadi yang
      // paling lama terbengkalai NOL PERNAH MUNCUL, sementara lima belas
      // teratas berputar tiap hari.
      //
      // ⚠ Itu bukan cacat tampilan, itu sebab tumpukannya. Antrean kerja
      // yang mendahulukan yang paling BARU memberi perhatian justru pada
      // yang paling belum membutuhkannya — dan yang tertua jadi tak terlihat
      // selamanya, persis pola 240 yang nol pernah turun.
      //
      // Efek sampingnya sengaja: badge "n hari menunggu" jadi benar-benar
      // menyala, karena baris yang tampil memang yang tua.
      const r = await api.get("/notifications", {
        params: { status_eq: "ACTIVE", limit: 15, urut: "terlama" },
      });
      setTugas(r.data?.items || []);
      // `total` dari server = jumlah SEBENARNYA yang terlihat pengguna ini.
      // Fallback ke panjang daftar hanya untuk backend lama; jangan jadikan
      // ia jalur normal — itu justru angka yang dulu berbohong.
      setTotalTugas(r.data?.total ?? (r.data?.items || []).length);
    } catch {
      setTugas([]);
      setTotalTugas(0);
    } finally {
      setLoadingTg(false);
    }
  }, []);

  useEffect(() => { loadTugas(); }, [loadTugas]);

  const loadRingkasan = useCallback(async () => {
    if (!showDeadlineCard) return;
    setLoadingRk(true);
    try {
      const r = await api.get("/dashboard/ringkasan");
      setRingkasan(r.data || null);
    } catch {
      setRingkasan(null);
    } finally {
      setLoadingRk(false);
    }
  }, [showDeadlineCard]);

  useEffect(() => { loadRingkasan(); }, [loadRingkasan]);

  const loadDeadlines = useCallback(async () => {
    if (!showDeadlineCard) return;
    // ⚠ SENGAJA NOL `setLoadingDl(true)` — sama alasannya dengan `loadTugas`.
    // Diukur 27 Agustus: kartu ini mengosongkan dirinya ~0,9 detik tiap
    // putaran 12 detik. Bukan macet, berkedip — dan berkedip pada kartu yang
    // gunanya dilirik sekilas berarti orang bisa melirik tepat saat isinya
    // tidak ada.
    try {
      // ⛔ 27 Sep 2026 (uji beban, 3 tahun data): dulu kartu ini memindai SELURUH FA
      //    (sampai 5.000 baris, 14 MB, 5,6 detik untuk Owner) TIAP 12 DETIK, lalu
      //    menyaring tenggat di browser — dan tetap bisa terpotong di 5.000. Sebelumnya
      //    lagi ia cuma menarik 200 baris dan menjawab "0 FA" yang benar karena untung.
      //    Sekarang satu panggilan kecil: server menyaring tenggat <= H+3, membuang
      //    status akhir, mengurutkan tenggat terdekat dulu, dan
      //    mengembalikan 10 teratas + TOTAL sesungguhnya. Nama customer ikut di baris.
      // ⛔ LUNAS-DINI-SISA-PEMBACA-01 (12 Okt 2026): LUNAS BUKAN status akhir — sejak pelunasan dini (K210) pesanan
      //    bisa lunas saat barangnya masih diproduksi, dan dulu tenggatnya hilang dari kartu ini. Yang dibuang kini
      //    status yang barangnya pasti sudah jadi / diserahkan / batal.
      const r = await api.get("/fa-orders", {
        params: {
          deadline_to: isoPlusDays(3),   // tanggal kalender LOKAL, bukan UTC
          status_kecuali: "SIAP_DISERAHKAN,DISERAHKAN,FREE_OF_CHARGE,CANCELLED,CLOSED",
          sort: "deadline_date", arah: "asc",
          limit: 10, offset: 0,
        },
      });
      const filtered = (r.data?.items || []).filter((f) => f.deadline_date);
      setDlTerpotong(false);
      setNearDeadline(filtered);
      const map = {};
      filtered.forEach((f) => { if (f.customer?.name) map[f.customer_id] = f.customer.name; });
      setCustMap(map);
    } catch {
      setNearDeadline([]);
    } finally {
      setLoadingDl(false);
    }
  }, [showDeadlineCard]);

  useEffect(() => { loadDeadlines(); }, [loadDeadlines]);

  // Jeda polling kartu tenggat. 12 detik MENIRU PaymentsPending, layar
  // sejenis di repo ini: sama-sama daftar ringkas berisi hal yang perlu
  // ditindaklanjuti, bukan layar detail yang sedang dikerjakan. Sengaja lebih
  // longgar daripada layar detail (8 detik) karena kartu ini dilihat sekilas.
  const DEADLINE_POLL_MS = 12000;

  // Realtime jalur utama; polling jaring pengaman (D108 — polling TIDAK
  // dicabut). Sebelum ini kartu tenggat NOL polling: sejak Juni ia memuat
  // sekali lalu diam, karena satu-satunya penyegarnya adalah realtime yang
  // ternyata tidak pernah menyala.
  const rtConnected = useRealtimeTable("fa_orders", loadDeadlines, {
    enabled: showDeadlineCard,
  });
  useVisiblePolling(
    loadDeadlines,
    rtConnected ? DEADLINE_POLL_MS : REALTIME_DOWN_POLL_MS,
    { enabled: showDeadlineCard }
  );

  // ⛔ K137 — butir per PERAN, diturunkan dari keadaan nyata tiap kali dibaca.
  //    Owner: "untuk yg perlu tindakan maka notif tidak hilang sebelum solved".
  //    Nol ada tombol tutup; butirnya hilang HANYA saat pekerjaannya selesai.
  const [butir, setButir] = useState(null);
  const [grafik, setGrafik] = useState(null);

  useEffect(() => {
    api.get("/dashboard/butir")
      .then(({ data }) => setButir(data))
      // ⚠ Kegagalan butir nol boleh menjatuhkan dashboard yang lain — sisanya
      //   tetap berguna, dan layar kosong total membuat orang mengira nol ada
      //   pekerjaan.
      .catch((e) => { setButir(null); toast.error(apiErrorMessage(e, "Data gagal dimuat.")); });
  }, []);

  useEffect(() => {
    if (!isOwner) return;
    api.get("/dashboard/grafik")
      .then(({ data }) => setGrafik(data))
      .catch((e) => { setGrafik(null); toast.error(apiErrorMessage(e, "Data gagal dimuat.")); });
  }, [isOwner]);

  const items = [
    { label: "Nama", value: profile?.full_name || "—", testId: "card-full-name" },
    { label: "Email", value: profile?.email || "—", testId: "card-email" },
    { label: "Peran", value: profile?.role?.name || "—", testId: "card-role" },
    { label: "Wilayah", value: profile?.region?.name || "Semua wilayah", testId: "card-region" },
    { label: "Cabang", value: profile?.store?.name || "Semua cabang", testId: "card-store" },
  ];

  return (
    <div className="max-w-5xl space-y-6" data-testid="dashboard-page">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Dashboard</h1>
        <p className="text-sm text-muted-foreground mt-1">Selamat datang di ETAMS Internal Operating System.
          {KPI_ROLES.includes(profile?.role?.code) && (
            <> · <Link to="/laporan/kpi" className="underline" data-testid="dashboard-ke-kpi">KPI ketepatan waktu</Link></>
          )}
          {ANALITIK_ROLES.includes(profile?.role?.code) && (
            <> · <Link to="/laporan/analitik" className="underline" data-testid="dashboard-ke-analitik">Analitik</Link></>
          )}
        </p>
      </div>

      {/* ⛔ PALING ATAS — aturan 2 draft dashboard: yang perlu TINDAKAN di
          depan, ringkasan di bawah. Bukan sebaliknya. */}
      {/* T100: satu daftar pekerjaan yang menunggu tangan saya, paling lama di atas. */}
      <KotakTugasSaya />

      <ButirDashboard data={butir} />

      {/* Grafik omzet + customer, HANYA Owner (permintaan Owner 31 Agu 2026). */}
      {isOwner && grafik && <GrafikOwner data={grafik} />}

      {showDeadlineCard && (
        <Card className="p-6" data-testid="dashboard-ringkasan-card">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-base font-semibold">
              Ringkasan Bulan Ini{ringkasan?.periode ? ` — ${ringkasan.periode}` : ""}
            </h2>
            <Badge variant="outline" className="text-xs">
              {isOwner ? "Semua wilayah" : "Wilayah Anda"}
            </Badge>
          </div>
          {loadingRk ? (
            <div className="text-sm text-muted-foreground py-4 text-center">Memuat...</div>
          ) : !ringkasan ? (
            <div className="text-sm text-muted-foreground py-4 text-center">
              Ringkasan tidak tersedia.
            </div>
          ) : (
            <>
              {/* "Omzet" SENGAJA tidak ada — nilai order dan uang masuk adalah
                  dua angka berbeda, dan menyatukannya adalah keputusan bisnis
                  yang belum dijatuhkan. Keduanya tampil berdampingan. */}
              {/* Uang masuk HARI INI berdiri sendiri di atas — ia belahan
                  pertama "omzet" menurut Owner, dan yang paling sering
                  ditanyakan. Sisanya angka bulanan. */}
              <div className="rounded border border-border bg-muted/30 p-4 mb-3" data-testid="rk-uang-hari-ini">
                <div className="text-xs text-muted-foreground">Uang masuk HARI INI</div>
                <div className="text-2xl font-bold">{formatIDR(ringkasan.uang_masuk?.hari_ini_idr ?? 0)}</div>
                <div className="text-[11px] text-muted-foreground mt-0.5">
                  {ringkasan.uang_masuk?.hari_ini_transaksi ?? 0} transaksi dikonfirmasi hari ini
                </div>
              </div>

              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
                <div className="rounded border border-border p-3" data-testid="rk-order-baru">
                  <div className="text-xs text-muted-foreground">Order baru</div>
                  <div className="text-lg font-semibold">{ringkasan.order_baru?.jumlah ?? 0}</div>
                  {/* Pecahan JUMLAH BARANG — bukan rupiah. */}
                  <div className="text-[11px] text-muted-foreground mt-1 leading-relaxed">
                    {ringkasan.order_baru?.qty?.jersey_atasan_saja ?? 0} atasan saja<br />
                    {ringkasan.order_baru?.qty?.jersey_set ?? 0} set<br />
                    {ringkasan.order_baru?.qty?.item_lain ?? 0} item lain
                  </div>
                </div>
                <div className="rounded border border-border p-3" data-testid="rk-nilai-order">
                  <div className="text-xs text-muted-foreground">Nilai order baru</div>
                  <div className="text-lg font-semibold">{formatIDR(ringkasan.order_baru?.nilai_total_idr ?? 0)}</div>
                </div>
                <div className="rounded border border-border p-3" data-testid="rk-uang-masuk">
                  <div className="text-xs text-muted-foreground">Uang masuk dikonfirmasi</div>
                  <div className="text-lg font-semibold">{formatIDR(ringkasan.uang_masuk?.total_idr ?? 0)}</div>
                  <div className="text-[11px] text-muted-foreground mt-0.5">
                    {ringkasan.uang_masuk?.jumlah_transaksi ?? 0} transaksi
                  </div>
                </div>
                <div className="rounded border border-border p-3" data-testid="rk-tanda-jadi">
                  <div className="text-xs text-muted-foreground">Tanda jadi baru</div>
                  <div className="text-lg font-semibold">{ringkasan.tanda_jadi_baru ?? 0}</div>
                </div>
                <div className="rounded border border-border p-3" data-testid="rk-customer-baru">
                  <div className="text-xs text-muted-foreground">Customer baru</div>
                  <div className="text-lg font-semibold">{ringkasan.customer_baru ?? 0}</div>
                </div>
                <div className="rounded border border-border p-3" data-testid="rk-customer-repeat">
                  <div className="text-xs text-muted-foreground">Customer repeat</div>
                  <div className="text-lg font-semibold">{ringkasan.customer_repeat ?? 0}</div>
                </div>
              </div>
              {ringkasan.terpotong && (
                <div className="text-xs text-warning-soft-foreground mt-3" data-testid="rk-terpotong">
                  ⚠ Data menyentuh plafon pengambilan — angka di atas adalah batas bawah, bukan nilai pasti.
                </div>
              )}
            </>
          )}
        </Card>
      )}

      {/* Tugas saya. ⚠ Urutan DIBALIK Owner 27 Agustus 2026: ringkasan
          omzet naik ke atas, kartu ini turun ke bawahnya.

          Versi sebelumnya menaruh kartu ini PALING ATAS dengan alasan
          "yang perlu DIKERJAKAN didahulukan daripada yang perlu dibaca"
          — itu bunyi K113. Owner mencabut bagian urutannya; sisa K113
          (lonceng dicabut, notifikasi jadi kartu) TETAP berlaku. */}
      <Card className="p-6" data-testid="dashboard-tugas-card">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <ListTodo size={18} className="text-primary" />
            <h2 className="text-base font-semibold">Tugas Saya</h2>
          </div>
          {/* ⚠ `totalTugas`, BUKAN `tugas.length`. Daftarnya dipotong 15;
              totalnya bisa 209. Badge yang menampilkan panjang halaman
              sebagai total membuat Owner membaca "15 aktif" saat 209 tugas
              menunggu — dan justru badge inilah satu-satunya angka di kartu
              ini yang orang percayai. */}
          <Badge variant="outline" className="text-xs">{totalTugas} aktif</Badge>
        </div>
        {loadingTg ? (
          <div className="text-sm text-muted-foreground py-4 text-center">Memuat...</div>
        ) : tugas.length === 0 ? (
          <div className="text-sm text-muted-foreground py-6 text-center" data-testid="dashboard-tugas-empty">
            Tidak ada tugas menunggu 🎉
          </div>
        ) : (
          <div className="space-y-4" data-testid="dashboard-tugas-list">
            {kelompokTugas.map((g) => {
              const Ikon = IKON_GRUP[g.ikon] || Circle;
              return (
                <div key={g.judul}>
                  {/* Sub-judul kelompok. Lima belas baris seragam jadi
                      beberapa blok pendek yang bisa DILEWATI sekilas — mata
                      berhenti di kelompok yang relevan, bukan membaca
                      lima belas judul lengkap tiap pagi. */}
                  <div className="flex items-center gap-1.5 mb-1.5">
                    <Ikon size={14} className="text-muted-foreground" />
                    <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                      {g.judul}
                    </span>
                    <span className="text-xs text-muted-foreground/70">({g.baris.length})</span>
                  </div>
                  <ul className="space-y-2">
                    {g.baris.map((n) => {
                      const tujuan = routeForNotif(n);
                      const hari = umurHari(n.created_at);
                      const esk = eskalasiTerjauh(n);
                      const isi = (
                        <>
                          <div className="min-w-0">
                            <div className="text-sm font-medium truncate">{n.title}</div>
                            {n.message && (
                              <div className="text-xs text-muted-foreground line-clamp-2 mt-0.5">{n.message}</div>
                            )}
                            {/* ⚠ Nama jenis DIBUANG dari baris ini — ia sudah
                                dibawa rel warna + ikon + sub-judul kelompok.
                                Mengulanginya di 11px cuma menambah teks yang
                                harus dilewati mata. */}
                            <div className="text-[11px] text-muted-foreground mt-1 flex items-center gap-1.5 flex-wrap">
                              <span>{formatDate(n.created_at)}</span>
                              {/* ⛔ KEADAAN ESKALASI. Mesinnya berjalan tiap
                                  pagi dan MELEBARKAN siapa yang menerima
                                  tugas ini — tapi sebelum hari ini, hasil
                                  kerjanya nol terlihat di layar mana pun.
                                  Tugas yang sudah dinaikkan ke Owner terbaca
                                  sama persis dengan yang baru masuk.

                                  Ditaruh di baris meta, BUKAN di samping
                                  badge umur: keduanya menjawab pertanyaan
                                  berbeda — umur "berapa lama", eskalasi
                                  "siapa lagi yang sekarang melihatnya". */}
                              {esk && (
                                <span
                                  data-testid={`tugas-eskalasi-${n.id}`}
                                  className={`px-1.5 py-0.5 rounded border text-[10px] ${
                                    esk.berat
                                      ? "bg-danger-soft text-danger-soft-foreground border-danger-soft-border"
                                      : "bg-muted text-muted-foreground border-border"
                                  }`}
                                >
                                  {esk.label}
                                  {esk.jumlah > 1 ? ` · ${esk.jumlah}×` : ""}
                                </span>
                              )}
                            </div>
                          </div>
                          {/* Badge umur. Datanya SUDAH ADA di `created_at` dan
                              selama ini dibuang ke teks 10px. Tugas yang
                              menunggu tiga hari terlihat berbeda dari yang
                              masuk pagi ini — itu satu-satunya sinyal urgensi
                              di kartu ini. */}
                          {hari !== null && hari >= 1 && (
                            <span
                              className={`shrink-0 text-[11px] px-1.5 py-0.5 rounded border ${
                                hari >= 3
                                  ? "bg-danger-soft text-danger-soft-foreground border-danger-soft-border"
                                  : "bg-warning-soft text-warning-soft-foreground border-warning-soft-border"
                              }`}
                            >
                              {hari} hari menunggu
                            </span>
                          )}
                        </>
                      );
                      // Rel warna kiri 3px per kelompok. Nol token baru —
                      // warnanya dari `lib/notifikasi`, yang memakai token
                      // tema, jadi ia ikut berbalik di mode terang/gelap.
                      const kelas =
                        `flex items-center justify-between gap-3 p-3 rounded border border-border border-l-[3px] ${g.rel}`;
                      // Tanpa tujuan yang jelas, barisnya TIDAK dibuat seolah
                      // bisa diklik — tombol yang tidak melakukan apa-apa
                      // lebih buruk daripada teks biasa.
                      return (
                        <li key={n.id} data-testid={`dashboard-tugas-${n.id}`}>
                          {tujuan ? (
                            <Link to={tujuan} className={`${kelas} hover:border-ring hover:bg-muted/50 transition-colors`}>
                              {isi}
                            </Link>
                          ) : (
                            <div className={kelas}>{isi}</div>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
        )}
        {/* Plafon yang BERSUARA. Kartu ini menampilkan 15 teratas; kalau
            totalnya lebih, pembaca WAJIB tahu — daftar tugas yang diam-diam
            memotong dirinya sendiri membuat orang mengira pekerjaannya
            habis padahal tinggal 194 lagi di bawah garis. */}
        {!loadingTg && totalTugas > tugas.length && (
          <div className="text-xs text-muted-foreground text-center pt-3" data-testid="dashboard-tugas-terpotong">
            Menampilkan {tugas.length} terbaru dari {totalTugas} tugas aktif.
          </div>
        )}
      </Card>

      {showDeadlineCard && (
        <Card className="p-6" data-testid="dashboard-deadline-card">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <Clock size={18} className="text-warning" />
              <h2 className="text-base font-semibold">FA Mendekati Deadline (≤3 hari)</h2>
            </div>
            <Badge variant="outline" className="text-xs">{nearDeadline.length} FA</Badge>
          </div>
          {loadingDl ? (
            <div className="text-sm text-muted-foreground py-4 text-center">Memuat...</div>
          ) : nearDeadline.length === 0 ? (
            <div className="text-sm text-muted-foreground py-6 text-center" data-testid="dashboard-deadline-empty">
              {dlTerpotong ? (
                <>
                  Tidak ada FA mendekati deadline di antara yang sempat dipindai.
                  <div className="text-xs mt-1">Daftar FA melebihi batas pindai — angka ini belum tentu lengkap.</div>
                </>
              ) : (
                <>Tidak ada FA mendekati deadline 🎉</>
              )}
            </div>
          ) : (
            <ul className="space-y-2">
              {nearDeadline.map((fa) => {
                const d = daysUntil(fa.deadline_date);
                const custName = custMap[fa.customer_id] || "—";
                return (
                  <li key={fa.id} data-testid={`dashboard-deadline-row-${fa.id}`}>
                    <Link
                      to={`/fa-orders/${fa.id}`}
                      className="flex items-center justify-between gap-3 p-3 rounded border border-border hover:border-ring hover:bg-muted/50 transition-colors"
                    >
                      <div className="min-w-0">
                        <div className="text-sm font-semibold truncate">{fa.fa_number}</div>
                        <div className="text-xs text-muted-foreground truncate">
                          {custName} · {fa.package_type} · {FA_STATUS_LABEL[fa.order_status] || fa.order_status}
                        </div>
                      </div>
                      <div className="flex items-center gap-3 shrink-0">
                        <div className="text-right">
                          <div className="text-xs text-muted-foreground">Deadline</div>
                          <div className="text-sm font-medium">{formatDate(fa.deadline_date)}</div>
                        </div>
                        {deadlineBadge(d)}
                      </div>
                    </Link>
                  </li>
                );
              })}
            </ul>
          )}
        </Card>
      )}

      <Card className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-base font-semibold">Profil Anda</h2>
          <Badge
            data-testid="dashboard-app-mode-badge"
            className={appMode?.mode === "PRODUCTION" ? "bg-success text-success-foreground" : "bg-info text-info-foreground"}
          >
            Mode: {appMode?.mode || "UAT"}
          </Badge>
        </div>
        <dl className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
          {items.map((it) => (
            <div key={it.label} data-testid={it.testId}>
              <dt className="text-xs uppercase tracking-wide text-muted-foreground">{it.label}</dt>
              <dd className="text-sm font-medium mt-0.5">{it.value}</dd>
            </div>
          ))}
        </dl>
      </Card>
    </div>
  );
}
